import { actions as plansActions } from '../plans';
import { initialized, initializeWithPlans, setWebAndMobileTestingTab } from './actions';
import { getCurrentWebAndMobileTab } from './selectors';
import {
  actions as subscriptionActions,
  selectors as subscriptionSelectors,
} from '../subscriptions';
import {
  TESTING_TYPES,
  PRODUCT_LIVE,
  PRODUCT_RDC,
  PRODUCT_VDC,
  CONFIG_STORAGE_KEY,
} from '../../constants';

export const initialize = () => (dispatch, getState) => {
  const subscriptionsLoading = subscriptionSelectors.isLoading(getState());

  const fetchSubscriptions = subscriptionsLoading ?
    dispatch(subscriptionActions.fetchSubscriptions()) :
    Promise.resolve();

  return fetchSubscriptions.then(() => {
    const state = getState();
    const subscriptionProducts = subscriptionSelectors
      .getProductsFromSubscriptionSelector(state);

    const actionsToDispatch = [
      plansActions.fetchPlansAction(),
    ];
    const initialTestingType = subscriptionSelectors.getSubscriptionsSelector(state)
      .map((sub) => sub.plan.testing_type)
      .find((testingType) => (
        [TESTING_TYPES.AUTOMATED_LIVE, TESTING_TYPES.LIVE].includes(testingType)),
      );
    if (initialTestingType && !getCurrentWebAndMobileTab(state)) {
      actionsToDispatch.push(setWebAndMobileTestingTab(initialTestingType));
    }

    if (Object.keys(subscriptionProducts).length) {
      actionsToDispatch.push(initializeWithPlans(subscriptionProducts));
    }

    const persistedConfig = JSON.parse(localStorage.getItem(CONFIG_STORAGE_KEY) || null);

    if (persistedConfig) {
      actionsToDispatch.push(initializeWithPlans(persistedConfig));
    }

    return Promise.all(
      actionsToDispatch.map(dispatch),
    ).then(() => dispatch(initialized()));
  });
};

export const setPurchase = (purchase) => (dispatch) => {
  dispatch(initializeWithPlans(purchase));
  if (Object.keys(purchase).includes(PRODUCT_LIVE)) {
    dispatch(setWebAndMobileTestingTab(TESTING_TYPES.LIVE));
  } else if (
    Object.keys(purchase).includes(PRODUCT_RDC) || Object.keys(purchase).includes(PRODUCT_VDC)
  ) {
    dispatch(setWebAndMobileTestingTab(TESTING_TYPES.AUTOMATED_LIVE));
  }
};

export const persistPurchaseData = () => (dispatch, getState) => {
  const { apps: { billing: { purchase } } } = getState();

  localStorage.setItem(
    CONFIG_STORAGE_KEY,
    JSON.stringify(purchase.toJS().configuration),
  );
};

export const clearPurchaseData = () => () => {
  localStorage.removeItem(CONFIG_STORAGE_KEY);
};
